import api from "../Interceptor";
import { toast } from "react-toastify";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getCurrencyName = async (currencyId) => {
  try {
    const { data: currencyData } = await api.get(
      `${API_BASE_URL}/api/v1/getAllCurrencies`
    );

    const matchedCurrency = currencyData.find(
      (currency) => currency._id === currencyId
    );

    return matchedCurrency ? matchedCurrency.name : "N/A";
  } catch (error) {
    toast.error("Failed to fetch currencies");
    console.error(error);
    return "N/A";
  }
};
